import { ProductLinePermission } from 'src/app/core/interfaces/permissions';
import { UsersRolesPage } from './pages';
import { Administrative } from './administrative.setup';

export const AdministrativeModule: ProductLinePermission = {
  id: Administrative.id,
  title: 'PAGE.ADMINISTRATIVE.TITLE',
  pages: [UsersRolesPage],
  showInSidebar: false,
};
